import React from 'react';
import { LucideIcon } from 'lucide-react';

interface IconWrapperProps {
  icon: LucideIcon;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const IconWrapper: React.FC<IconWrapperProps> = ({ 
  icon: Icon, 
  className = "", 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  };

  return (
    <Icon className={`${sizeClasses[size]} text-coral-500 ${className}`} />
  );
};

// Export common icon components for easy reuse
export { IconWrapper as Icon };